"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function handleClick(elem, onValueChange) {
    onValueChange(elem);
}
const OfferDetailDropdown = ({ onValueChange, values, }, isOpen, ref) => {
    const selectedValue = values.filter((elem) => elem.active === true)[0].getLabel();
    return react_1.default.createElement("div", { ref: ref, className: `dropdown-container${isOpen ? ' open' : ''} dropdown-item` },
        react_1.default.createElement("div", { className: "dropdown-current-item", dangerouslySetInnerHTML: { __html: selectedValue } }),
        react_1.default.createElement("ul", { className: "dropdown-list" }, values.map((elem) => react_1.default.createElement("li", { className: `${elem.active === true ? 'selected' : ''} dropdown-item`, key: `${elem.getKey()}`, onClick: () => handleClick(elem, onValueChange), dangerouslySetInnerHTML: { __html: elem.getLabel() } }))));
};
exports.default = OfferDetailDropdown;
